"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainBasedOnExperience = exports.sortData = exports.descComparator = exports.parseLocation = exports.flattenLocales = exports.flattenObj = exports.getTestIdAttribute = exports.darkenColor = exports.lightenColor = exports.generateStyleId = exports.sheetsRegistry = exports.createStyleSheet = exports.generateUUID = exports.extendTheme = exports.setGlobalFonts = exports.useCssReset = exports.constructShadowStyles = exports.constructVariantStyles = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const polished_1 = require("polished");
const react_jss_1 = require("react-jss");
const uuid_1 = require("uuid");
const react_router_dom_1 = require("react-router-dom");
const router_1 = require("next/router");
const Contants_1 = require("./Contants");
const ThemeProvider_1 = require("./ThemeProvider");
const __DEV__ = process.env.NODE_ENV !== 'production';
/**
 * @param mergingObjs - array of style objects to merge when constructing a theme
 */
const constructVariantStyles = (mergingObjs) => {
    let obj = {};
    mergingObjs.forEach(mO => {
        obj = (0, merge_1.default)(obj, mO);
    });
    return obj;
};
exports.constructVariantStyles = constructVariantStyles;
/**
 * used to construct box shadow styles. Default values are provided for override when needed
 * @param values
 * x = 0px
 * y = 4px
 * blur = 20px
 * spread = 0px
 * color = rgba(rgba(41, 56, 49, 0.15)
 */
const constructShadowStyles = (values) => {
    const { x = '0px', y = '4px', blur = '20px', spread = '0px', color = 'rgba(41, 56, 49, 0.15)' } = values;
    return {
        '-moz-box-shadow': `${x} ${y} ${blur} ${spread} ${color}`,
        '-webkit-box-shadow': `${x} ${y} ${blur} ${spread} ${color}`,
        'box-shadow': `${x} ${y} ${blur} ${spread} ${color}`,
    };
};
exports.constructShadowStyles = constructShadowStyles;
/**
 * useCssRest leverages a CSS reset to allow for clean styling from the start. This should be applied when the
 * app mounts (as high as possible in the tree).
 */
const useCssReset = () => {
    if (global.document && global.window) {
        const link = global.document.getElementById('cssReset');
        if (!link) {
            const { host } = global.window.location;
            const baseUrl = (host === null || host === void 0 ? void 0 : host.includes('.groma.com'))
                ? 'https://assets.groma.com'
                : (host === null || host === void 0 ? void 0 : host.includes('.preprod-groma.com'))
                    ? 'https://assets.preprod-groma.com'
                    : 'https://assets.sandbox-groma.com';
            const cssReset = global.document.createElement('link');
            cssReset.id = 'cssReset';
            cssReset.rel = 'stylesheet';
            cssReset.href = `${baseUrl}/reset.css`;
            global.document.head.appendChild(cssReset);
        }
    }
};
exports.useCssReset = useCssReset;
/**
 * setGlobalFonts will set the fonts link in the head of the document
 */
const setGlobalFonts = () => {
    if (global.document && global.window) {
        const link = global.document.getElementById('fontUrl');
        if (!link) {
            const { host } = global.window.location;
            const baseUrl = (host === null || host === void 0 ? void 0 : host.includes('.groma.com'))
                ? 'https://assets.groma.com'
                : (host === null || host === void 0 ? void 0 : host.includes('.preprod-groma.com'))
                    ? 'https://assets.preprod-groma.com'
                    : 'https://assets.sandbox-groma.com';
            const fontUrl = global.document.createElement('link');
            fontUrl.id = 'fontUrl';
            fontUrl.rel = 'stylesheet';
            fontUrl.href = `${baseUrl}/fonts/fonts.css`;
            global.document.head.appendChild(fontUrl);
        }
    }
};
exports.setGlobalFonts = setGlobalFonts;
/**
 * @param baseTheme - acting base theme
 * @param newTheme - theme that is going to extend from the base theme
 */
const extendTheme = (baseTheme, newTheme) => {
    return (0, merge_1.default)({}, baseTheme, newTheme);
};
exports.extendTheme = extendTheme;
/**
 * @param useShort boolean to generate a short UUID
 * @param charCount character count to return with short enabled
 */
const generateUUID = (useShort = true, charCount = 6) => {
    const uuid = (0, uuid_1.v4)().split('-').join('');
    return useShort ? uuid.substring(0, charCount) : uuid;
};
exports.generateUUID = generateUUID;
const createStyleSheet = (styles, options) => (0, react_jss_1.createUseStyles)(styles, options);
exports.createStyleSheet = createStyleSheet;
exports.sheetsRegistry = react_jss_1.SheetsRegistry;
exports.generateStyleId = react_jss_1.createGenerateId;
/**
 * @param amount % amount to modify the color
 * @param color hex color
 */
const lightenColor = (amount, color) => (0, polished_1.lighten)(amount, color);
exports.lightenColor = lightenColor;
/**
 * @param amount % amount to modify the color
 * @param color hex color
 */
const darkenColor = (amount, color) => (0, polished_1.darken)(amount, color);
exports.darkenColor = darkenColor;
/**
 * @param testId string of testId
 */
const getTestIdAttribute = (testId) => {
    const attrList = {};
    const testIdAttrList = ['data-testid'];
    const __persist__ = process.env.CYPRESS_PERSIST_TESTID === 'true';
    if ((__DEV__ || __persist__) && testId) {
        testIdAttrList.forEach(attr => (attrList[attr] = testId));
        return attrList;
    }
    else
        return attrList;
};
exports.getTestIdAttribute = getTestIdAttribute;
/**
 * Flattens Object to a single string with `.` separating keys
 * @param obj
 * @param parent
 * @param res
 */
const flattenObj = (obj, parent, res = {}) => {
    for (const key of Object.keys(obj)) {
        const propName = parent ? `${parent}.${key}` : key;
        if (typeof obj[key] === 'object') {
            (0, exports.flattenObj)(obj[key], propName, res);
        }
        else {
            res[propName] = obj[key];
        }
    }
    return res;
};
exports.flattenObj = flattenObj;
/**
 * FlattenLocales to be a string separated by `.` for FormattedMessage usage.
 * @param locales
 */
const flattenLocales = (locales) => {
    var _a;
    return (0, exports.flattenObj)((_a = locales.default) !== null && _a !== void 0 ? _a : locales);
};
exports.flattenLocales = flattenLocales;
/**
 * parseLocation is an util method that returns a pathname based on router type
 * intended to be leveraged for next and react apps
 * @param router
 */
const parseLocation = (router) => {
    if (router === ThemeProvider_1.RouterTypes.NEXT_ROUTER) {
        const { pathname } = (0, router_1.useRouter)();
        return { pathname };
    }
    else if (router === ThemeProvider_1.RouterTypes.REACT_ROUTER) {
        const { pathname } = (0, react_router_dom_1.useLocation)();
        return { pathname };
    }
    else {
        return { pathname: '' };
    }
};
exports.parseLocation = parseLocation;
/**
 * descending comparison method
 * @param a - object
 * @param b - object
 * @param orderBy - key to order by
 */
const descComparator = (a, b, orderBy) => {
    const first = a[orderBy];
    const second = b[orderBy];
    if (typeof first === 'number' && typeof second === 'number') {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }
    else {
        if (b[orderBy].toLowerCase() < a[orderBy].toLowerCase()) {
            return -1;
        }
        if (b[orderBy].toLowerCase() > a[orderBy].toLowerCase()) {
            return 1;
        }
        return 0;
    }
};
exports.descComparator = descComparator;
/**
 * method that sorts data based on sortType (descending / ascending)
 */
const sortData = (data, orderBy, sortType) => {
    const clonedData = [...data];
    if (orderBy) {
        if (sortType === Contants_1.SortType.DESC) {
            return clonedData.sort((a, b) => (0, exports.descComparator)(a, b, orderBy));
        }
        else {
            return clonedData.sort((a, b) => -(0, exports.descComparator)(a, b, orderBy));
        }
    }
    else
        return data;
};
exports.sortData = sortData;
const getDomainBasedOnExperience = (domains, exp) => {
    switch (exp) {
        case 'investors':
            return domains.investors;
        case 'identity':
            return domains.identity;
        case 'holdings':
            return domains.holdings;
        default:
            return domains.landing;
    }
};
exports.getDomainBasedOnExperience = getDomainBasedOnExperience;
